<template>
  <div>
    <v-dialog v-model="localMFADialog" persistent max-width="500">
      <v-card class="py-2">
        <v-card-text class="d-flex pb-4">
          <p class="text-h5 font-weight-bold title">
            Multi-Factor Authentication Required
          </p>
        </v-card-text>
        <v-card-text class="pt-0">
          <v-row class="mb-1">
            <v-col cols="12">
              <p class="justify-left responsive">
                You have not activated Multi-Factor Authentication (MFA) on your account. For your security, please enable MFA to continue.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-col>
            <v-btn
              class="text-white"
              height="45"
              block
              color="primary"
              @click="openDialogPw = true"
            >
              {{ isMobile ? "Active MFA" : "Active Multi-Factor Authentication" }}
            </v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

   <dialogPw 
      :show.sync="openDialogPw"
      @sendResponse="sendResponse"
    ></dialogPw>

    <dialog-qr
      :modelValue.sync="openDialogQr"
      :urlQr="urlQr"
      :secretQr="secretQr"
    />
    </div>
</template>

<script>
import dialogPw from "../profile/dialog-password.vue";
import dialogQr from "../profile/dialogQr.vue";

export default {
  props: {
    MFADialog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    dialogPw,
    dialogQr
  },
  data() {
    return {
      localMFADialog: this.MFADialog,
      openDialogPw: false,
      openDialogQr: false,
      urlQr: "",
      secretQr: "",
      isMobile: false,
    };
  },
  computed: {
    userprofile() {
      return this.$store.getters["ManageProfile/dataProfile"];
    },
    hasUserProfile() {
      return !!this.userprofile && Object.keys(this.userprofile).length > 0;
    }
  },
  async mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;

    await this.initMFA(this.$route.path);
  },
  watch: {
    '$route.path'(newPath) {
      this.initMFA(newPath);
    }
  },
  methods: {
    async initMFA(path) {
      if (!path.startsWith("/project") && !path.startsWith("/manage-organization")) {
        this.localMFADialog = false;
        return;
      }
      try {
        let profile;
        if (this.userprofile) {
          profile = this.userprofile;
        } else {
          profile = await this.$store.dispatch("ROLEPERMISSION/fetchUserProfile");
        }
        this.localMFADialog = profile.enfoce_mfa && !profile.is_mfa_active;
      } catch (err) {
        this.localMFADialog = false;
      }
    },
    sendResponse(event) {
      this.urlQr = event.urlQr;
      this.secretQr = event.secretQr;
      this.openDialogPw = false;
      this.openDialogQr = true;
    }
  }
};
</script>

<style>
.responsive {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;          
  text-align: left; 
}
/* .v-dialog {
} */

@media only screen and (min-width: 375px) {
  .v-dialog {
    /* min-width: 90% !important;
    max-width: 95% !important; */
    box-shadow: none !important;

  }

  .title {
    text-align: center; 
  }
}
</style>
